'use strict';

var React = require('react'),
    _ = require('underscore'),
    ShareAddButtons = require('../molecules/ShareAddButtons'),
    UserStore = require('../stores/UserStore'),
    SidebarActionCreators = require('../actions/SidebarActionCreators'),
    SidebarTypes = require('../constants/SidebarTypes'),
    ContextMenuActionCreators = require('../actions/ContextMenuActionCreators'),
    ContextMenuTypes = require('../constants/ContextMenuTypes'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    ScreenSizeMixin = require('../mixins/ScreenSizeMixin'),
    ShareTypes = require('../constants/ShareTypes'),
    ShareActionCreators = require('../actions/ShareActionCreators'),
    { isMobile } = require('../utils/Browser'),
    { PropTypes } = React;

var ShareAddStamp = React.createClass({
  mixins: [ScreenSizeMixin, PureRenderMixin],

  propTypes: {
    stamp: PropTypes.object.isRequired,
    primaryServices: PropTypes.arrayOf(
      PropTypes.oneOf(_.values(ShareTypes))
    ),
    showAddLabel: PropTypes.bool,
    size: PropTypes.any,
    split: PropTypes.bool,
    fill: PropTypes.bool
  },

  contextTypes: {
    source: React.PropTypes.string.isRequired
  },

  getDefaultProps() {
    return {
      primaryServices: []
    };
  },

  getDisplayOptions() {
    var stamp = this.props.stamp,
        isMyStamp = UserStore.isMe(stamp.user),
        primaryServices = this.props.primaryServices,
        showShareButton = primaryServices.length === 0,
        showEditMenu = isMyStamp && this.state.isDesktop && !isMobile(),
        showMoreButton = showEditMenu || !showShareButton,
        addButtonLabel;

    if (this.state.isDesktop && this.props.showAddLabel) {
      addButtonLabel = isMyStamp ? 'Submit to Collections' : 'Add to Collections';
    }

    return {
      showEditMenu: showEditMenu,
      showShareButton: showShareButton,
      showMoreButton: showMoreButton,
      addButtonLabel: addButtonLabel
    };
  },

  render() {
    var {
      showShareButton,
      showMoreButton,
      addButtonLabel
    } = this.getDisplayOptions();

    return (
      <ShareAddButtons size={this.props.size}
                       onShareClick={this.handleShareClick}
                       onAddClick={this.handleAddClick}
                       onMoreClick={this.handleMoreClick}
                       context={this.props.context}
                       color={this.props.color}
                       primaryServices={this.props.primaryServices}
                       showMore={showMoreButton}
                       showShare={showShareButton}
                       addLabel={addButtonLabel}
                       split={this.props.split}
                       round={this.props.round}
                       overlay={this.props.overlay}
                       fill={this.props.fill} />
    );
  },

  handleAddClick() {
    SidebarActionCreators.showSidebar(SidebarTypes.ADD_STAMP_TO_ZINES, {
      stampId: this.props.stamp.id
    });
  },

  handleShareClick(e, service) {
    var el = e.target,
        stampId = this.props.stamp.id;

    if (service) {
      ShareActionCreators.shareStamp({
        stampId: stampId,
        service: service,
        source: this.context.source
      });
    } else {
      ContextMenuActionCreators.showContextMenu(ContextMenuTypes.STAMP_SHARE, el, {
        stampId: stampId,
        source: this.context.source
      });
    }
  },

  handleMoreClick(e) {
    var {
      showEditMenu,
      showShareButton
    } = this.getDisplayOptions();

    var secondaryServices;
    if (!showShareButton) {
      secondaryServices = _.difference(_.values(ShareTypes), this.props.primaryServices);
    }

    ContextMenuActionCreators.showContextMenu(ContextMenuTypes.STAMP_MORE, e.target, {
      stampId: this.props.stamp.id,
      showEdit: showEditMenu,
      shareServices: secondaryServices,
      source: this.context.source
    });
  }
});

module.exports = ShareAddStamp;



/** WEBPACK FOOTER **
 ** ./organisms/ShareAddStamp.jsx
 **/